// UI Components
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

interface ProfileHistoryProps {
  profileId: string;
}

export function ProfileHistory({ }: ProfileHistoryProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>History</CardTitle>
        <CardDescription>Profile update history</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">No history for this profile</p>
      </CardContent>
    </Card>
  );
}

export default ProfileHistory;
